var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmployee = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08317 9.66675C2.08317 9.66675 5.83317 11.3334 9.99984 11.3334C14.1665 11.3334 17.9165 9.66675 17.9165 9.66675M13.3332 5.50008C13.3332 3.65913 11.8408 2.16675 9.99984 2.16675C8.15889 2.16675 6.6665 3.65913 6.6665 5.50008M6.6665 9.66675V12.1667M13.3332 9.66675V12.1667M6.99984 18.8334H12.9998C14.8667 18.8334 15.8001 18.8334 16.5131 18.4701C17.1403 18.1505 17.6503 17.6406 17.9699 17.0134C18.3332 16.3003 18.3332 15.3669 18.3332 13.5001V10.8334C18.3332 8.96657 18.3332 8.03315 17.9699 7.32011C17.6503 6.69291 17.1403 6.18297 16.5131 5.86339C15.8001 5.50008 14.8667 5.50008 12.9998 5.50008H6.99984C5.13299 5.50008 4.19957 5.50008 3.48654 5.86339C2.85933 6.18297 2.34939 6.69291 2.02982 7.32011C1.6665 8.03315 1.6665 8.96657 1.6665 10.8334V13.5001C1.6665 15.3669 1.6665 16.3003 2.02982 17.0134C2.34939 17.6406 2.85933 18.1505 3.48654 18.4701C4.19957 18.8334 5.13299 18.8334 6.99984 18.8334Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmployee);
export default ForwardRef;